// 現場連絡表 新規作成・更新画面
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  LinearProgress,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  useMediaQuery
} from '@material-ui/core';
import { DialogProps } from '@material-ui/core/Dialog';
import { createStyles, makeStyles, withStyles } from '@material-ui/core/styles';
import AddToPhotosIcon from '@material-ui/icons/AddToPhotos';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SearchIcon from '@material-ui/icons/Search';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import 'date-fns';
import React, { useCallback, useEffect, useState } from 'react';
import { Redirect, useHistory, useParams, useLocation } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { getConstructionDetails } from '../apicalls/construction';
import { getEmployeeMasterList } from '../apicalls/employeeMaster';
import { getUnitMasterList } from '../apicalls/unitMaster';
import {
  createSiteContact,
  getSiteContactDetails,
  getSiteContactExportDetails,
  updateSiteContact
} from '../apicalls/siteContact';
import { savePdf } from '../apicalls/savePdf';
import '../App.css';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import { DatePickerInput } from '../components/atoms';
import LoadingComponent from '../components/LoadingComponent';
import { DateField } from '../components/molecules';
import NumberInput from '../components/NumberInput';
import { siteContactPdf } from '../generatePdf/siteContactPdf';
import { btnColor, isLoggedIn, mainBlueColor, userRole } from '../GlobalState';
import { parsePrice } from '../utils';
import './List.css';
import {
  SITE_CONTACTS_ITEM_MAX,
  EMPLOYEE_TYPE,
  EMPLOYEE_STATUS
} from '../const/Const';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import { TTopicPathState } from '../components/topicPath/type/Type';
import { DOCUMENT_TYPE } from '../const/Const';
import HelpIcon from '@material-ui/icons/Help';
import { getUserSelectOptions } from '../utils/processAndTaskFormUtils';
import { StaffData } from '../types/staffData';
import { getStaffSelectOptions } from '../utils/getStaffSelectOptions';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

export const EditSiteContacts: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [userPermission] = useRecoilState(userRole);
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [userData, setUserData] = useState([]);
  const [vendorData, setVendorData] = useState([]);
  const [vendorDataSearch, setVendorDataSearch] = useState([]);
  const [mUnitsData, setMUnitsData] = useState([]);

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  // 現場連絡表用state
  const [documentNumber, setDocumentNumber] = useState('');
  const [constructionName, setConstructionName] = useState<string>('');
  const [constructId, setConstructId] = useState<number>(0);
  const [foreman, setForeman] = useState('');
  const [siteContactRemarks, setSiteContactRemarks] = useState('');
  const [constructDate, setConstructDate] = useState('');
  const [selectedConstructDate, setSelectedConstructDate] =
    useState<Date | null>(null);
  const [meetupTime, setMeetupTime] = useState('');
  const [workCompany, setWorkCompany] = useState('');
  const [siteSupervizor, setSiteSupervizor] = useState('');
  const [siteSupervizorTel, setSiteSupervizorTel] = useState('');
  const [contactNote, setContactNote] = useState('');
  const [submissionDate, setSubmissionDate] = useState('');
  const [selectedSubmissionDate, setSelectedSubmissionDate] =
    useState<Date | null>(null);
  const [siteContactDetailData, setSiteContactDetailData] = useState<any>({});
  const handleConstructDateChange = (date: Date | null) => {
    setSelectedConstructDate(date);
    var finaldate: any = date?.toISOString().split('T')[0];
    setConstructDate(finaldate);
  };
  const handleSubmissionDateChange = (date: Date | null) => {
    setSelectedSubmissionDate(date);
    var finaldate: any = date?.toISOString().split('T')[0];
    setSubmissionDate(finaldate);
  };
  const [constructionDetailsList, setConstructionDetailsList] = useState(['']);
  const [specList, setSpecList] = useState([]);
  const [quantityList, setQuantityList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [remarksList, setRemarksList] = useState([]);
  const [rowCount, setRowCount] = useState<any>([1]);
  const [userId, setUserId] = useState<number>(0);
  const [encryptedJsonData, setEncryptedJsonData] = useState<any>(null);
  const [itemIds, setItemIds] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [showLinearProgress, setShowLinearProgress] = useState(false);
  const [openSelectModal, setopenSelectModal] = useState(false);
  const [addRowButton, setAddRowButton] = useState<boolean>(true);

  const [initialUserData, setInitialUserData] =
    useState<StaffData | null>(null);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const matches2 = useMediaQuery('(min-width:900px)');

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontWeight: 'bold',
        fontSize: 16
      },
      table1: {},
      inputBottom: {
        height: 30,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputQuantityBottom: {
        height: 30,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1,
        textAlign: 'right'
      },
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'scroll'
      },
      paper: {
        width: matches2 ? 600 : '80%'
      },

      subContainer: {
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      },
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 60,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input: {
        minHeight: 40,
        maxHeight: 100,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },

      inputMainContainer1: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 80,
        alignItems: 'center',
        width: '100%'
      },
      textMainContainer1: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 80,
        alignItems: 'center'
      },
      textContainer1: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input1: {
        minHeight: 60,
        width: '100%'
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      textContainerPrice: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        textAlign: 'right',
        width: '100%'
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        minHeight: 48,
        width: '100%'
      },
      fixedTextContainer: {
        fontSize: 14,
        marginLeft: 15
      },
      inputPostalCode: {
        height: 40,
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      progress: {
        backgroundColor: '#c1c1c1',
        '& .MuiLinearProgress-barColorPrimary': {
          backgroundColor: mainColor
        }
      },
      memoContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        height: 80,
        alignItems: 'center'
      },
      memoMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        height: 80,
        alignItems: 'center',
        width: '100%'
      },
      memoInput: {
        height: 60,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      }
    })
  );

  const classes = useStyles();
  const history: any = useHistory();
  const params: any = useParams();
  const location: any = useLocation();

  // 項目リストが更新された際の処理(行の追加と削除)
  useEffect(() => {
    setAddRowButton(true);
  }, [rowCount.length]);

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const getListOfUsers = useCallback(() => {
    getEmployeeMasterList('', 1, 0, EMPLOYEE_TYPE['INSIDE_EMPLOYEE']).then(
      data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setUserData(data.data);
            }
          }
        }
      }
    );
  }, [changeLoggedInData]);
  //選択中の現場連絡番号
  const { id: site_contact_id }: any = useParams();
  const getTheDetailsOfSiteContacts = (
    newSiteContactId: any = null,
    goPreview = false
  ) => {
    getSiteContactDetails(
      newSiteContactId ? newSiteContactId : site_contact_id
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            if (newSiteContactId) {
              //code for checking whether the data is updated or not, if any data is updated new pdf will be generated and uploaded
              let isDataUpdated: boolean = false;

              if (siteContactDetailData['items']) {
                if (
                  siteContactDetailData['items'].length !==
                  data.data['items'].length
                ) {
                  isDataUpdated = true;
                } else {
                  for (
                    let i = 0;
                    i < siteContactDetailData['items'].length;
                    i++
                  ) {
                    if (
                      siteContactDetailData['items'][i].construction_name !==
                      data.data['items'][i].construction_name
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      siteContactDetailData['items'][i].spec !==
                      data.data['items'][i].spec
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      siteContactDetailData['items'][i].quantity !==
                      data.data['items'][i].quantity
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      siteContactDetailData['items'][i].unit !==
                      data.data['items'][i].unit
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      siteContactDetailData['items'][i].remarks !==
                      data.data['items'][i].remarks
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                  }
                }
              }

              if (isDataUpdated === false) {
                let oldData = Object.keys(siteContactDetailData);
                let updatedData = Object.keys(data.data);
                oldData = oldData.filter(
                  (char: any, aa: any) => char !== 'items'
                );
                updatedData = updatedData.filter(
                  (char: any, aa: any) => char !== 'items'
                );

                if (oldData.length !== updatedData.length) {
                  isDataUpdated = true;
                } else {
                  for (let el of updatedData) {
                    if (siteContactDetailData[el] !== data.data[el]) {
                      isDataUpdated = true;
                      break;
                    }
                  }
                }
              }

              // pdfとpreview
              if (isDataUpdated) {
                uploadSiteContactPdf(data.data, newSiteContactId, goPreview);
              } else {
                setShowLinearProgress(false);
                setOpenSuccess(true);
                if (goPreview === true) {
                  history.replace(
                    `/site-contacts/${newSiteContactId}/preview`,
                    {
                      rowId: history.location.state.rowId,
                      previouspath: history.location.state.previouspath,
                      params: history.location.state.params,
                      newSiteContactId: newSiteContactId,
                      constructId: history.location.state.constructId,
                      tabs: history.location.state.tabs
                    }
                  );
                }
              }
            }

            // 現場連絡表用
            if (data.data.user_status === EMPLOYEE_STATUS.INACTIVE) {
              const initialUserData: StaffData = {
                name: data.data.user_name,
                id: data.data.user_id
              };
              setInitialUserData(initialUserData);
            } else {
              setInitialUserData(null);
            }
            setSiteContactDetailData(data.data);
            setDocumentNumber(data.data.code);
            setConstructionName(data.data.construction_name);
            setUserId(data.data.user_id);
            setConstructId(data.data.construct_id);
            setForeman(data.data.foreman);
            setSiteContactRemarks(data.data.site_contact_remarks);
            setConstructDate(data.data.construct_date);
            if (data.data.construct_date !== '') {
              setSelectedConstructDate(data.data.construct_date);
            }
            setMeetupTime(data.data.meetup_time);
            setWorkCompany(data.data.work_company);
            setSiteSupervizor(data.data.site_supervizor);
            setSiteSupervizorTel(data.data.site_supervizor_tel);
            setContactNote(data.data.contact_note);
            setSubmissionDate(data.data.submission_date);
            if (data.data.submission_date !== '') {
              setSelectedSubmissionDate(data.data.submission_date);
            }

            let iIds: any = [];
            data.data.items.map((k: any, index: number) => {
              let iRowCount: any = rowCount;
              iRowCount[index] = 1;
              setRowCount(iRowCount);

              iIds.push(k.id);

              let iConstructionDetailsList: any = constructionDetailsList;
              iConstructionDetailsList[index] = k.construction_name;
              setConstructionDetailsList(iConstructionDetailsList);

              let iSpecList: any = specList;
              iSpecList[index] = k.spec;
              setSpecList(iSpecList);

              let iQuantityList: any = quantityList;
              iQuantityList[index] = k.quantity;
              setQuantityList(iQuantityList);

              let iUnitList: any = unitList;
              iUnitList[index] = k.unit;
              setUnitList(iUnitList);

              let iRemarksList: any = remarksList;
              iRemarksList[index] = k.remarks;
              setRemarksList(iRemarksList);

              return <></>;
            });
            setItemIds(iIds);
            setLoading(false);
          }
        }
      }
    });
  };

  //upload pdf
  const uploadSiteContactPdf = async (
    pdfData: any,
    newSiteContactId: number,
    goPreview: boolean
  ) => {
    let blob = await siteContactPdf(pdfData);
    const formData: any = new FormData();
    formData.append(
      'document_type_id',
      JSON.stringify(DOCUMENT_TYPE.SITE_CONTACT)
    );
    formData.append('site_contact_id', JSON.stringify(newSiteContactId));
    formData.append('file_obj', blob);

    savePdf(formData).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setShowLinearProgress(false);
            setOpenSuccess(true);
            if (goPreview === true) {
              history.replace(`/site-contacts/${newSiteContactId}/preview`, {
                rowId: history.location.state.rowId,
                previouspath: history.location.state.previouspath,
                params: history.location.state.params,
                newSiteContactId: newSiteContactId,
                constructId: history.location.state.constructId,
                tabs: history.location.state.tabs
              });
            } else {
              if (!params.id) {
                history.push(`/site-contacts/${newSiteContactId}/edit`, {
                  state: newSiteContactId
                });
              }
            }
          }
        }
      }
    });
  };

  const getListOfMUnits = useCallback(() => {
    getUnitMasterList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setMUnitsData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const createOrUpdateSiteContactDetails = (goPreview: boolean = false) => {
    // 保存前のデータチェック用の配列
    let items: any = [];

    // ローダー表示
    setShowLinearProgress(true);
    for (let i = 0; i < constructionDetailsList.length; i++) {
      let lenName = constructionDetailsList.length;
      let lenId = itemIds.length;
      let newArr1 = Array(lenName - lenId).fill(0);
      let concatArray1 = itemIds;
      let concatArray2 = concatArray1.concat(newArr1);
      setItemIds(concatArray2);

      items[i] = {
        id: concatArray2[i],
        construction_name: constructionDetailsList[i],
        spec: specList[i],
        quantity: quantityList[i],
        unit: parseInt(unitList[i]) === 0 ? null : unitList[i],
        remarks: remarksList[i]
      };
    }

    let arr: any = [];
    for (let n = 0; n < items.length; n++) {
      arr.push(items[n]);
    }

    if (params.id) {
      updateFunction(arr, goPreview);
    } else {
      createFunction(arr, goPreview);
    }
  };

  const createFunction = (myNewArr: any, goPreview: boolean = false) => {
    createSiteContact(
      history.location.state.constructId, //counstruct_idが入ってる
      userId,
      foreman,
      siteContactRemarks,
      selectedConstructDate !== null ? constructDate : '',
      meetupTime,
      workCompany,
      siteSupervizor,
      siteSupervizorTel,
      contactNote,
      selectedSubmissionDate !== null ? submissionDate : '',
      myNewArr,
      history.location.state.estimateReceivedId
        ? history.location.state.estimateReceivedId
        : null
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setErrorMessage(data.message);
            setOpenSuccess(true);
            getTheDetailsOfSiteContacts(data.new_site_contact_id, goPreview);
          }
        }
      }
    });
  };

  // update
  const updateFunction = (myNewArr: any, goPreview: boolean = false) => {
    updateSiteContact(
      params.id,
      userId,
      foreman,
      siteContactRemarks,
      selectedConstructDate !== null ? constructDate : '',
      meetupTime,
      workCompany,
      siteSupervizor,
      siteSupervizorTel,
      contactNote,
      selectedSubmissionDate !== null ? submissionDate : '',
      myNewArr
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            getTheDetailsOfSiteContacts();
            setErrorMessage(data.message);
            getListOfUsers();
            getTheDetailsOfSiteContacts(parseInt(params.id), goPreview);
          }
        }
      }
    });
  };

  const initializeSiteContact = useCallback(() => {
    getConstructionDetails(history.location.state.constructId).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setConstructionName(data.data.name);
            setWorkCompany(
              history.location.state.estimateId
                ? history.location.state.clientName
                : data.data.client_name
            );
            setSiteSupervizor(history.location.state.clientChargeName);
            setLoading(false);
          }
        }
      }
    });
  }, [changeLoggedInData, history.location.state.rowId]);

  const getEncryptedJsonDataToExport = useCallback(() => {
    getSiteContactExportDetails(params.id).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setEncryptedJsonData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData, params.id]);

  const initializeSiteContactItemsFromEstimate = () => {
    setLoading(false);
    history.location.state.estimateItems.forEach((k: any, index: number) => {
      let iRowCount: any = rowCount;
      iRowCount[index] = 1;
      setRowCount(iRowCount);

      let iConstructionDetailsList: any = constructionDetailsList;
      iConstructionDetailsList[index] = k.name;
      setConstructionDetailsList(iConstructionDetailsList);

      let iSpecList: any = specList;
      iSpecList[index] = k.spec;
      setSpecList(iSpecList);

      let iQuantityList: any = quantityList;
      // 見積書の数量が空欄である場合は0に変える
      let importQuantity = k.costQuantity ? k.costQuantity : 0;
      iQuantityList[index] = parseFloat(importQuantity);
      setQuantityList(iQuantityList);

      let iUnitList: any = unitList;
      iUnitList[index] = k.costUnitId;
      setUnitList(iUnitList);

      let iRemarksList: any = remarksList;
      iRemarksList[index] = k.remarks;
      setRemarksList(iRemarksList);

      index++;
    });
  };

  useEffect(() => {
    if (params.id) {
    }
  }, [params.id, getEncryptedJsonDataToExport]);

  useEffect(() => {
    getListOfUsers();
    getListOfMUnits();
    if (params.id) {
      getTheDetailsOfSiteContacts();
    } else {
      initializeSiteContact();
    }
    if (history.location.state.estimateId) {
      setUserId(
        history.location.state.creator ? history.location.state.creator : 0
      );
      setWorkCompany(history.location.state.clientName);
      initializeSiteContactItemsFromEstimate();
    }
  }, []);

  useEffect(() => {
    const date = new Date();
    setSelectedSubmissionDate(date);
    var finaldate: any = date?.toISOString().split('T')[0];
    setSubmissionDate(finaldate);
  }, []);

  const handleOpenSelectModal = () => {
    setopenSelectModal(true);
  };
  const handleCloseSelectModal = () => {
    setopenSelectModal(false);
    setVendorData(vendorDataSearch);
  };

  const [fullWidth] = useState(true);
  const [maxWidth] = useState<DialogProps['maxWidth']>('xs');

  // パンくずリスト用に検索パラメーターを設定
  const patternState: TTopicPathState = {};
  patternState['/site-contacts'] = history.location.state;

  // パンくずリスト表示パターン(編集)
  let patternName = 'site_contacts_edit';

  // 新規作成画面のモードの場合
  if (location.pathname.match('create')) {
    // 遷移元画面のURL取得
    const url: string | undefined = location.state.url;
    // パンくずリスト表示パターン(新規)
    patternName = 'site_contacts_create';
  }

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <>
      <AppBarComponent
        patternName='site_contacts_edit'
        patternState={patternState}
      />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent isFormGroup={true} />
        </>
      ) : (
        <div
          style={{
            overflow: 'hidden',
            backgroundColor: '#F5F5F5',
            minHeight: window.innerHeight - 120
          }}
        >
          <div style={{ margin: 15 }}>
            <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
              <Alert onClose={handleClose} severity='error'>
                {errorMessage}
              </Alert>
            </Snackbar>

            <Snackbar
              open={openSuccess}
              autoHideDuration={4000}
              onClose={handleCloseSuccess}
            >
              <Alert onClose={handleCloseSuccess} severity='success'>
                {errorMessage}
              </Alert>
            </Snackbar>

            <Dialog
              open={openAlert}
              onClose={handleCloseAlert}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
            >
              <DialogTitle id='alert-dialog-title'>
                {'削除しますか？'}
              </DialogTitle>
              <DialogActions>
                <Button onClick={handleCloseAlert} color='primary'>
                  キャンセル
                </Button>
                <Button
                  onClick={() => {
                    handleCloseAlert();
                  }}
                  color='primary'
                  autoFocus
                >
                  削除
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              fullWidth={fullWidth}
              maxWidth={maxWidth}
              open={openSelectModal}
              onClose={handleCloseSelectModal}
              scroll='paper'
              aria-labelledby='set_construct_title'
              aria-describedby='constructs'
            >
              <DialogActions></DialogActions>
            </Dialog>

            <div className='table-top-container-customer'>
              <div style={{ fontWeight: 'bold' }}>
                <Button
                  style={{
                    minWidth: 90,
                    marginRight: 15,
                    color: '#758283',
                    backgroundColor: '#F5F5F5',
                    marginBottom: !matches2 ? 10 : 0
                  }}
                  variant='contained'
                  color='secondary'
                  onClick={() => {
                    //戻る先を判定する
                    if (history.location.state.estimateId) {
                      history.replace(
                        `/estimates/${history.location.state.estimateId}/edit`,
                        history.location.state
                      );
                    } else if (
                      history.location.state.params ||
                      history.location.state.tabs
                    ) {
                      if (
                        history.location.state.previouspath ===
                        'to_construction'
                      ) {
                        //工事一覧画面へ
                        history.replace(
                          `/constructions_document/${history.location.state.rowId}/edit`,
                          history.location.state
                        );
                      } else {
                        //現場連絡票一覧へ
                        history.push('/site-contacts', history.location.state);
                      }
                    } else {
                      if (history.location.state?.currentPage) {
                        history.push('/site-contacts', history.location.state);
                      } else {
                        history.goBack();
                      }
                    }
                  }}
                  startIcon={<ArrowBackIcon />}
                >
                  戻る
                </Button>
              </div>
            </div>

            {showLinearProgress && (
              <LinearProgress className={classes.progress} />
            )}

            <div style={{ backgroundColor: '#FFFFFF', paddingBottom: 40 }}>
              <div className='table-top-container-customer'>
                <div
                  style={{
                    fontWeight: 'bold',
                    padding: 15,
                    paddingBottom: 0,
                    fontSize: 24
                  }}
                >
                  {params.id ? '現場連絡表編集' : '現場連絡表新規作成'}
                </div>
              </div>

              <Grid container>
                <Grid item xs={matches2 ? 4 : 12}>
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        現場連絡表番号
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.fixedTextContainer}>
                        {documentNumber}
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>工事件名</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.fixedTextContainer}>
                        {constructionName}
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>職長</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={foreman}
                            maxLength={20}
                            placeholder='最大20文字'
                            type='text'
                            onChange={text => {
                              setForeman(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>備考</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <textarea
                          value={siteContactRemarks}
                          maxLength={210}
                          placeholder=''
                          onChange={text => {
                            setSiteContactRemarks(text.target.value);
                          }}
                          className={classes.input}
                        />
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  {/* <DateField
                    text="工事日"
                    id="construct_date"
                    date={selectedConstructDate}
                    emptyLabel="日付を選択"
                    onChange={handleConstructDateChange}
                    span={true}
                  /> */}

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>工事日</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div
                        style={{
                          marginLeft: 10,
                          marginRight: 15,
                          backgroundColor: '#FFFFFF',
                          height: 42,
                          paddingBottom: 5,
                          paddingLeft: 5,
                          width: '100%'
                        }}
                        className={'select-div-div'}
                      >
                        <DatePickerInput
                          id='construct_date'
                          date={selectedConstructDate}
                          emptyLabel='日付を選択'
                          onChange={handleConstructDateChange}
                        />
                      </div>
                    </div>
                  </div>
                </Grid>

                <Grid item xs={matches2 ? 4 : 12}>
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>集合時間</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <input
                          value={meetupTime}
                          maxLength={19}
                          placeholder=''
                          type='text'
                          onChange={text => {
                            setMeetupTime(text.target.value);
                          }}
                          className={classes.input}
                        />
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>施工会社</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={workCompany}
                            maxLength={30}
                            placeholder='最大30文字'
                            type='text'
                            onChange={text => {
                              setWorkCompany(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>現場担当者</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={siteSupervizor}
                            maxLength={20}
                            placeholder='最大20文字'
                            type='text'
                            onChange={text => {
                              setSiteSupervizor(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>現場担当者TEL</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={siteSupervizorTel}
                            maxLength={20}
                            placeholder=''
                            type='text'
                            onChange={text => {
                              setSiteSupervizorTel(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>連絡事項</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <textarea
                          value={contactNote}
                          maxLength={210}
                          placeholder=''
                          onChange={text => {
                            setContactNote(text.target.value);
                          }}
                          className={classes.input}
                        />
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                </Grid>

                <Grid item xs={matches2 ? 4 : 12}>
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>担当者氏名</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainerSelectBox}>
                        <select
                          value={userId}
                          onChange={text => {
                            setUserId(parseInt(text.target.value));
                          }}
                          className={classes.selectBoxStyle}
                          name='cars'
                          id='cars'
                          form='carform'
                        >
                          <option value={0}>選択してください</option>
                          {getStaffSelectOptions(userData, initialUserData)}
                        </select>
                      </div>
                    </div>
                  </div>

                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  {/* <DateField
                    text="提出日"
                    id="submission_date"
                    date={selectedSubmissionDate}
                    emptyLabel="日付を選択"
                    onChange={handleSubmissionDateChange}
                    span={true}
                  /> */}

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>提出日</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div
                        style={{
                          marginLeft: 10,
                          marginRight: 15,
                          backgroundColor: '#FFFFFF',
                          height: 42,
                          paddingBottom: 5,
                          paddingLeft: 5,
                          width: '100%'
                        }}
                        className={'select-div-div'}
                      >
                        <DatePickerInput
                          id='submission_date'
                          date={selectedSubmissionDate}
                          emptyLabel='日付を選択'
                          onChange={handleSubmissionDateChange}
                        />
                      </div>
                    </div>
                  </div>

                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                </Grid>
              </Grid>

              <div style={{ margin: 15, marginTop: 40 }}>
                <TableContainer component={Paper}>
                  <Table className={classes.main} aria-label='customized table'>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell className={classes.table} align='left'>
                          工事内容
                        </StyledTableCell>
                        <StyledTableCell className={classes.table} align='left'>
                          仕様
                        </StyledTableCell>
                        <StyledTableCell className={classes.table} align='left'>
                          数量
                        </StyledTableCell>
                        <StyledTableCell className={classes.table} align='left'>
                          単位
                          <CustomTooltip
                            title={tooltipContents.itemUnit}
                            placement='right'
                          >
                            <HelpIcon
                              style={{ marginLeft: 8, marginBottom: 4 }}
                            />
                          </CustomTooltip>
                        </StyledTableCell>
                        <StyledTableCell className={classes.table} align='left'>
                          備考
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table}
                          align='left'
                        ></StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rowCount.map((i: any, j: number) => (
                        <StyledTableRow>
                          <StyledTableCell
                            className={classes.table1}
                            style={{ minWidth: 140 }}
                            align='left'
                          >
                            {/*  //工事内容 */}
                            <input
                              value={constructionDetailsList[j]}
                              maxLength={60}
                              placeholder='最大60文字'
                              onChange={text => {
                                let newNameArr: any = [
                                  ...constructionDetailsList
                                ];
                                newNameArr[j] = text.target.value;
                                setConstructionDetailsList(newNameArr);
                              }}
                              className={classes.inputBottom}
                            />
                          </StyledTableCell>

                          <StyledTableCell
                            className={classes.table1}
                            style={{ minWidth: 140 }}
                            align='left'
                          >
                            {/*  //仕様 */}
                            <input
                              value={specList[j]}
                              maxLength={60}
                              placeholder='最大60文字'
                              onChange={text => {
                                let newNameArr: any = [...specList];
                                newNameArr[j] = text.target.value;
                                setSpecList(newNameArr);
                              }}
                              className={classes.inputBottom}
                            />
                          </StyledTableCell>

                          <StyledTableCell
                            className={classes.table1}
                            style={{ minWidth: 140 }}
                            align='left'
                          >
                            {/*  //数量 */}
                            <input
                              value={quantityList[j]}
                              type='number'
                              min='0'
                              max='99999'
                              onChange={text => {
                                if (text.target.value.length > 8) {
                                  text.target.value = text.target.value.slice(
                                    0,
                                    8
                                  );
                                }
                                text.preventDefault();
                                let newNameArr: any = [...quantityList];
                                newNameArr[j] = parseFloat(text.target.value);
                                setQuantityList(newNameArr);
                              }}
                              className={classes.inputQuantityBottom}
                              onWheel={(e: any) => e.target.blur()}
                            />
                          </StyledTableCell>

                          <StyledTableCell
                            className={classes.table1}
                            style={{ minWidth: 140 }}
                            align='left'
                          >
                            {/*  //単位 */}
                            <select
                              value={unitList[j]}
                              onChange={text => {
                                let newNameArr: any = [...unitList];
                                newNameArr[j] = text.target.value;
                                setUnitList(newNameArr);
                              }}
                              className={classes.inputBottom}
                              style={{ height: 35 }}
                              name='cars'
                              id='cars'
                              form='carform'
                            >
                              <option value={0}>選択してください</option>
                              {mUnitsData.map((i: any) => (
                                <option value={i.id}>{i.name}</option>
                              ))}
                            </select>
                          </StyledTableCell>

                          <StyledTableCell
                            className={classes.table1}
                            style={{ minWidth: 140 }}
                            align='left'
                          >
                            {/*  //備考 */}
                            <input
                              value={remarksList[j]}
                              maxLength={60}
                              placeholder='最大60文字'
                              onChange={text => {
                                let newNameArr: any = [...remarksList];
                                newNameArr[j] = text.target.value;
                                setRemarksList(newNameArr);
                              }}
                              className={classes.inputBottom}
                            />
                          </StyledTableCell>

                          <StyledTableCell
                            className={classes.table1}
                            align='right'
                          >
                            <Button
                              style={{
                                backgroundColor: buttonColor
                              }}
                              variant='contained'
                              color='primary'
                              onClick={() => {
                                const rowCountResult = rowCount.filter(
                                  (item: any, index: number) => index !== j
                                );
                                setRowCount(rowCountResult);

                                const constructionDetailsListResult =
                                  constructionDetailsList.filter(
                                    (item: any, index: number) => index !== j
                                  );
                                setConstructionDetailsList(
                                  constructionDetailsListResult
                                );

                                const specListResult = specList.filter(
                                  (item: any, index: number) => index !== j
                                );
                                setSpecList(specListResult);

                                const quantityListResult = quantityList.filter(
                                  (item: any, index: number) => index !== j
                                );
                                setQuantityList(quantityListResult);

                                const unitListResult = unitList.filter(
                                  (item: any, index: number) => index !== j
                                );
                                setUnitList(unitListResult);

                                const remarksListResult = remarksList.filter(
                                  (item: any, index: number) => index !== j
                                );
                                setRemarksList(remarksListResult);

                                const itemIdsResult = itemIds.filter(
                                  (item: any, index: number) => index !== j
                                );
                                setItemIds(itemIdsResult);
                              }}
                            >
                              削除
                            </Button>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>

              {addRowButton && (
                <div style={{ position: 'absolute', right: 30 }}>
                  <CustomTooltip
                    title={tooltipContents.outsourcedPurchaseOrder}
                    placement='left'
                  >
                    <Button
                      style={{ backgroundColor: buttonColor }}
                      variant='contained'
                      color='secondary'
                      startIcon={<AddToPhotosIcon />}
                      onClick={() => {
                        setRowCount([...rowCount, 1]);
                        setConstructionDetailsList([
                          ...constructionDetailsList,
                          ''
                        ]);
                      }}
                    >
                      追加
                    </Button>
                  </CustomTooltip>
                </div>
              )}

              <div style={{ height: 10, backgroundColor: '#FFFFFF' }}></div>
            </div>
          </div>
          <div style={{ height: 80 }} />

          <div
            className='save-btn-container'
            style={{
              backgroundColor: '#FFFFFF',
              position: 'fixed',
              bottom: 0,
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              padding: 20
            }}
          >
            <div>
              <CustomTooltip title={tooltipContents.preview} placement='top'>
                <Button
                  style={{
                    marginRight: 15,
                    marginBottom: 0,
                    backgroundColor: buttonColor
                  }}
                  variant='contained'
                  color='primary'
                  disabled={showLinearProgress}
                  onClick={() => {
                    createOrUpdateSiteContactDetails(true);
                  }}
                >
                  プレビュー
                </Button>
              </CustomTooltip>
              <Button
                style={{
                  marginRight: 30,
                  marginBottom: 0,
                  backgroundColor: buttonColor
                }}
                variant='contained'
                color='primary'
                disabled={showLinearProgress}
                onClick={() => {
                  createOrUpdateSiteContactDetails();
                }}
              >
                保存
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
